var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-wrap",attrs:{"id":_vm.containerId}},[_c('div',{staticClass:"slider__image-wrap"},[_c('iframe',{staticClass:"responsive-iframe",attrs:{"frameborder":"0","width":"845","height":"476","src":_vm.videoUrl}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }